import { PhoneType } from "../../Enums/ChoiceEnums";
import { IEntityInfoById, IEntityNamesModel } from "../Models/EntityModel"

export function standardName(entity?: IEntityNamesModel): string | undefined {
    if (!entity)
        return;

    return `${entity?.lastName}, ${entity?.firstName}`;
}

// Get the phone info for a specified phone type
export function phoneInfo(entityInfo?: IEntityInfoById, phoneType?: PhoneType): IPhoneInfo|undefined {
    switch(phoneType)
    {
        case PhoneType.Home:
        return { phone: entityInfo?.homePhone, ext: entityInfo?.homePhoneExt, phoneType: phoneType }

        case PhoneType.Work:
        return { phone: entityInfo?.workPhone, ext: entityInfo?.workPhoneExt, phoneType: phoneType }

        case PhoneType.Other:
        return { phone: entityInfo?.otherPhone, ext: entityInfo?.otherPhoneExt, phoneType: phoneType }

        case PhoneType.Fax:
        return { phone: entityInfo?.faxPhone, ext: entityInfo?.faxPhoneExt, phoneType: phoneType }
    }
}
export interface IPhoneInfo
{
    phone?: string, 
    ext?: string,
    phoneType: PhoneType
};
